import { RegistrationOverview } from '~/@pages_auth/register/register_ui/RegistrationOverview'
import { PhoneInfo } from './PhoneInfo'

function PhoneVerificationSideMenu({ isCompany }: { isCompany: boolean }) {
  return (
    <div className="flex flex-col gap-10">
      <RegistrationOverview isCompany={isCompany} />
      <PhoneInfo />
    </div>
  )
}

export { PhoneVerificationSideMenu }
